import React, { useState } from 'react'
import FaqCard from './FaqCard'
import PopupComp from '../Popups/PopupComp';
import ContactCard from './ContactCard';
import SupportCTA from '../support/SupportCta';
import FaqCards from './FaqCards';

const FaqSection = () => {
  const [popup, setPopup] = useState(false);

  const onClose = () => setPopup(false);
  const onClick = (e) => {
    e.preventDefault();
    setPopup(true);
  };

  return (
    <section className="py-20 w-full max-w-5xl mx-auto px-6">
      {popup && (
        <PopupComp onClose={onClose}>
          <ContactCard onClose={onClose} />
        </PopupComp>
      )}

      {/* Header */}
      <div className='text-center mb-16'>
        <h2 className='text-blue-600 font-bold tracking-widest uppercase text-sm mb-3'>Support</h2>
        <h1 className='font-extrabold text-3xl sm:text-5xl text-gray-900'>
          Frequently Asked Questions
        </h1>
        <p className="text-gray-500 mt-4 text-lg">
          Everything you need to know about placements and using CampusIRA.
        </p>
      </div>

      {/* FAQ Grid/List */}
      <FaqCards/>
      {/* Modern CTA Box */}
      <SupportCTA/>
    </section>
  );
}

export default FaqSection;